import { callZigzagFunction } from '../../callZigzagFunction';

// send user activity log
// 유저 활동 로그 전송
export const sual = (type: 'action' | 'app' | 'info', log: string) => {
  callZigzagFunction('sual')({ log: `${type}/${log}` });
};
